import React, { Fragment, useRef, useState, useEffect } from "react";
import { Btn, H4, Breadcrumbs } from "../../../../AbstractElements";
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { Row, Col, Card, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Input } from 'reactstrap'
import { Save, AddUserTxt, firstnameTxt, lastnameTxt, emailTxt, hireDateTxt, StatusMapping, userTypeMapping, salaryTxt, bonusTxt, userTypeTxt, phoneTxt, terminationDateTxt, sendEmailTxt } from '../../../../Constant';
import FsLightbox from 'fslightbox-react';
import userimg from '../../../../assets/images/user/user.png';
import DatePicker from 'react-datepicker';
import {
    createUserProfile,
    getNextEmployeeID,
    isTerminatedStatus,
    serializeUserDate,
} from '../userFirebase';
import { createAdminOperationTracker } from '../../../../utils/adminDataMutationClient';
import i18n from '../../../../i18n';

const AddUser = () => {
    const { handleSubmit } = useForm();
    const [imgToggle, setImgToggle] = useState(false);
    const photoInputRef = useRef(null);
    const operationTrackerRef = useRef(null);

    if (!operationTrackerRef.current) {
        operationTrackerRef.current = createAdminOperationTracker();
    }

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [hireDate, setHireDate] = useState(new Date());
    const [salary, setSalary] = useState('');
    const [phone, setPhone] = useState('');
    const [bonus, setBonus] = useState('0');
    const [userStatus, setUserStatus] = useState('Actif');
    const [userType, setUserType] = useState('Agent');
    const [endDate, setEndDate] = useState('');
    const [userPhoto, setUserPhoto] = useState('');
    const [employeeID, setEmployeeID] = useState('');
    const [sendPasswordEmail, setSendPasswordEmail] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loadingCompleted, setLoadingCompleted] = useState(false);

    const [errorFirstName, setErrorFirstName] = useState(false);
    const [errorLastName, setErrorLastName] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorHireDate, setErrorHireDate] = useState(false);
    const [errorEndDate, setErrorEndDate] = useState(false);
    const [errorSalary, setErrorSalary] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const [errorUserType, setErrorUserType] = useState(false);
    const [errorForm, setErrorForm] = useState(false);

    const [errorFormMsg, setErrorFormMsg] = useState('');
    const [errorFieldMsg, setErrorFieldMsg] = useState(i18n.t('Dashboard_Users_FieldRequired'));
    const [errorEmailMsg, setErrorEmailMsg] = useState('');
    const [errorSalaryMsg, setErrorSalaryMsg] = useState('');

    useEffect(() => {
        getAllEmployeeIDs();
    }, []);

    const profilePhoto = userPhoto || userimg;

    const handlePhotoButtonClick = (event) => {
        event.preventDefault();
        photoInputRef.current?.click();
    };

    const handlePhotoChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            return;
        }

        setErrorForm(false);
        setErrorFormMsg('');

        if (!file.type.startsWith('image/')) {
            setErrorForm(true);
            setErrorFormMsg('Veuillez choisir un fichier image valide.');
            event.target.value = '';
            return;
        }

        if (file.size > 500 * 1024) {
            setErrorForm(true);
            setErrorFormMsg('Veuillez choisir une image de moins de 500 Ko.');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onload = () => setUserPhoto(String(reader.result || ''));
        reader.onerror = () => {
            setErrorForm(true);
            setErrorFormMsg("Impossible de charger l'image selectionnee.");
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    };

    const validateForm = (e) => {

        let isValid = true // By Default the form is set to be valid.

        if (!firstName) { setErrorFirstName(true); isValid = false; } else { setErrorFirstName(false); }

        if (!lastName) { setErrorLastName(true); isValid = false; } else { setErrorLastName(false); }

        if (!phone) { setErrorPhone(true); isValid = false; } else { setErrorPhone(false); }

        if (!email) { setErrorEmail(true); setErrorEmailMsg('Veuillez entrer une addresse courriel'); isValid = false; }
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) { setErrorEmail(true); setErrorEmailMsg('Veuillez entrer une addresse courriel valide par exemple : John.Smith@email.com'); isValid = false; }
        else { setErrorEmail(false); }

        if (!hireDate) { setErrorHireDate(true); isValid = false; } else { setErrorHireDate(false); }

        if (!salary) {
            setErrorSalary(true);
            setErrorSalaryMsg('Veuillez entrer un salaire');
            isValid = false;



        } else if (!/^[0-9]{0,2}(\.[0-9]{2})?$/i.test(salary)) {
            setErrorSalaryMsg('Veuillez entrer un salaire format : 00.00');
            setErrorSalary(true);
            isValid = false;
        }

        return isValid;
    }

    const onAddSubmit = async (data) => {

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        setLoadingCompleted(false);
        setErrorForm(false);
        setErrorFormMsg('');

        const newUserRequest = {
            useremail: email,
            email: email,
            phone: phone,
            firstname: firstName,
            lastname: lastName,
            photo: userPhoto,
            hiredate: serializeUserDate(hireDate),
            usertype: userType,
            userstatus: userStatus,
            status: userStatus,
            salary: salary,
            bonus: bonus,
            sendpassword: sendPasswordEmail,
            terminationdate: serializeUserDate(endDate),
        };
        const operation = 'user.create';
        const subjectId = '';
        const operationId = await operationTrackerRef.current.forSubmission({
            operation,
            subjectId,
            fields: newUserRequest,
        });

        try {
            const result = await createUserProfile(newUserRequest, operationId);
            setEmployeeID(result.employeeId);
            operationTrackerRef.current.markSucceeded();
            setLoadingCompleted(true);
        } catch (error) {
            console.error(error);
            setLoading(false);
            setLoadingCompleted(false);
            setErrorForm(true);
            setErrorFormMsg(error.message || "Impossible de sauvegarder l'utilisateur pour le moment.");
        }
    }

    const twoDecimalFormat = event => {
        let key = event.key || event.charCode;
        let textVal = event.target.value;

        if (event.key != "Backspace") {
            if (/^[0-9]{2}$/i.test(textVal)) {
                event.target.value = event.target.value + ".";
            }
        }

    };


    async function getAllEmployeeIDs() {
        try {
            setEmployeeID(await getNextEmployeeID());
        } catch (error) {
            console.error(error);
            setEmployeeID(1000);
        }
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle={i18n.t('Dashboard_Breadcrumb_Users')} parent={i18n.t('Dashboard_Breadcrumb_Users')} title={i18n.t('Dashboard_Users_Add')} />

            {!loading
                ?
                <Form className="card" onSubmit={handleSubmit(onAddSubmit)}>
                    <CardHeader className="pb-0">
                        <H4 attrH4={{ className: "card-title mb-0" }}>{AddUserTxt}</H4>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="8">
                                <span className={`error-form ${!errorForm ? 'hidden' : 'fadeIn'}`}>{errorFormMsg}</span>
                                <Row>
                                    <Col md="4">
                                        <div className="profile-title">
                                            <H4 attrH4={{ className: "card-title m-t-20 f-16" }}>{i18n.t('Dashboard_Users_Employee')} : {employeeID}</H4>
                                            <div className="media m-l-0">
                                                <FsLightbox openOnMount={false} types={["image"]} toggler={imgToggle} sources={[profilePhoto]} />
                                                <img src={profilePhoto} alt="Galerie" className="media paymodal-img m-l-0 img-thumbnail media" onClick={(event) => {
                                                    imgToggle ? setImgToggle(false) : setImgToggle(true);
                                                }} />

                                            </div>
                                        </div>
                                        <div className="form-footer">
                                            <input
                                                ref={photoInputRef}
                                                type="file"
                                                accept="image/*"
                                                className="d-none"
                                                onChange={handlePhotoChange}
                                            />
                                            <Btn attrBtn={{ className: 'btn-block m-b-20 m-t-20', color: 'primary', type: 'button', onClick: handlePhotoButtonClick }}>{i18n.t('Dashboard_Users_ChangePhoto')}</Btn>
                                        </div>
                                    </Col>
                                    <Col md="8">
                                        <Row>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{firstnameTxt}</Label>
                                                    <Input className="form-control" type="text" placeholder={firstnameTxt} value={firstName} onChange={e => setFirstName(e.target.value)} />
                                                    <span className={`error-form ${!errorFirstName ? 'hidden' : 'fadeIn'}`}>{errorFieldMsg}</span>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{lastnameTxt}</Label>
                                                    <Input className="form-control" type="text" placeholder={lastnameTxt} value={lastName} onChange={e => setLastName(e.target.value)} />
                                                    <span className={`error-form ${!errorLastName ? 'hidden' : 'fadeIn'}`}>{errorFieldMsg}</span>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{phoneTxt}</Label>
                                                    <Input className="form-control" type="text" placeholder={phoneTxt} value={phone} onChange={e => setPhone(e.target.value)} />
                                                    <span className={`error-form ${!errorPhone ? 'hidden' : 'fadeIn'}`}>{errorFieldMsg}</span>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{emailTxt}</Label>
                                                    <Input className="form-control" type="text" placeholder={emailTxt} value={email} onChange={e => setEmail(e.target.value)} />
                                                    <span className={`error-form ${!errorEmail ? 'hidden' : 'fadeIn'}`}>{errorEmailMsg}</span>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{hireDateTxt}</Label>
                                                    <div className="daterange-card">
                                                        <div className="theme-form">
                                                            <FormGroup >
                                                                <DatePicker
                                                                    className="form-control digits"
                                                                    onChange={(updateDate) => setHireDate(updateDate)}
                                                                    startDate={hireDate}
                                                                    selected={hireDate}
                                                                    calendarStartDay={1}
                                                                    dropdownMode="select"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    todayButton={i18n.t('Dashboard_LatestActivity_Today')}
                                                                    placeholderText={hireDateTxt}
                                                                />
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                    <span className={`error-form ${!errorHireDate ? 'hidden' : 'fadeIn'}`}>{errorFieldMsg}</span>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{salaryTxt}</Label>
                                                    <Input className="form-control" type="text" placeholder={salaryTxt} value={salary}
                                                        onChange={e => setSalary(e.target.value)}
                                                        onKeyDown={(event) => twoDecimalFormat(event)}
                                                        onKeyPress={(event) => {

                                                            if (errorSalary) {
                                                                setErrorSalary(false);
                                                            }

                                                            if (!/^[0-9.\x08]+$/.test(event.key)) {
                                                                event.preventDefault();
                                                                setErrorSalaryMsg('Veuillez entrer des numéros seulement')
                                                                setErrorSalary(true);
                                                            }

                                                            if (event.target.value.length > 4) {
                                                                event.target.value = event.target.value.substr(0, 4);
                                                            }
                                                        }}


                                                    />
                                                    <span className={`error-form ${!errorSalary ? 'hidden' : 'fadeIn'}`}>{errorSalaryMsg}</span>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label">{bonusTxt}</Label>
                                                    <Input className="form-control" type="text" placeholder={bonusTxt} value={bonus} onChange={e => setBonus(e.target.value)} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup>
                                                    <Label className="form-label">{userTypeTxt}</Label>
                                                    <Input type="select" name="select" className="form-control btn-square" value={userType} onChange={e => setUserType(e.target.value)}>
                                                        {userTypeMapping.map((items, i) =>
                                                            <option key={i} value={items}>{items}</option>
                                                        )};
                                                    </Input>
                                                    <span className={`error-form ${!errorUserType ? 'hidden' : 'fadeIn'}`}>{errorFieldMsg}</span>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" sm="6" md="6">
                                                <FormGroup>
                                                    <Label className="form-label">{i18n.t('Dashboard_Users_Status')}</Label>
                                                    <Input type="select" name="select" className="form-control btn-square" value={userStatus} onChange={e => setUserStatus(e.target.value)}>
                                                        {StatusMapping.map((items, i) =>
                                                            <option key={i} value={items}>{items}</option>
                                                        )};
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            {isTerminatedStatus(userStatus)
                                                ?
                                                <Col xs="6" sm="6" md="6">
                                                    <FormGroup className="mb-3">
                                                        <Label className="form-label">{terminationDateTxt}</Label>
                                                        <DatePicker
                                                            className="form-control digits"
                                                            startDate={endDate}
                                                            selected={endDate}
                                                            calendarStartDay={1}
                                                            onChange={(date) => setEndDate(date)}
                                                            dropdownMode="select"
                                                            dateFormat="yyyy-MM-dd"
                                                            todayButton={i18n.t('Dashboard_LatestActivity_Today')}
                                                            placeholderText={terminationDateTxt}
                                                            minDate={new Date(hireDate)}
                                                        />
                                                        <span className={`error-form ${!errorEndDate ? 'hidden' : 'fadeIn'}`}>{errorFieldMsg}</span>
                                                    </FormGroup>
                                                </Col>
                                                : ""
                                            }

                                        </Row>
                                        <Col xs="12" sm="12" md="12">
                                            <FormGroup className="mb-3">
                                                <div className="checkbox checkbox-solid-primary">
                                                    <Input id="solid3" type="checkbox" checked={sendPasswordEmail} onChange={e => setSendPasswordEmail(e.target.checked)} />
                                                    <Label for="solid3">{sendEmailTxt}</Label>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody >
                    <CardFooter className="text-end">
                        <Btn attrBtn={{ color: "primary", type: "submit" }} >{Save}</Btn>
                    </CardFooter>
                </Form >
                :
                <Card>
                    <CardBody>
                        <Card className="no-border">
                            <Row>
                                <Col md='12'>
                                    <p class='p-t-30 text-center text-bold'>{i18n.t('Dashboard_Users_StayOnPage')} <br /></p>
                                    <p class='p-t-0 text-center'>{i18n.t('Dashboard_Users_CreatingUser')} : {employeeID} </p>

                                    <div className={`loader-box loading-paymodal`}>
                                        {!loadingCompleted

                                            ?
                                            <div class='loader-container paymodal-loading-container m-t-40 m-b-40'>
                                                <div class='loader-box paymodal-loader-box'>
                                                    <div class='paycard-loader'></div>
                                                </div>
                                            </div>

                                            : <div class='loader-container paymodal-loading-container  m-b-40'>
                                                <i className='fa fa-check-circle f-80 m-t-30 f-color-primary'></i>
                                              </div>

                                        }

                                        {!loadingCompleted

                                            ? <h3 class='loading-message f-color-primary f-20 m-t-40'>{i18n.t('Dashboard_Users_PleaseWait')}</h3>

                                            : <h3 class='loading-message f-color-primary f-20 m-t-40'>{i18n.t('Dashboard_Users_Success')}</h3>

                                        }

                                        {!loadingCompleted

                                        ? <p class='p-t-0 text-center'>{i18n.t('Dashboard_Users_Redirecting')}</p>

                                        :  <Link to={`${process.env.PUBLIC_URL}/dashboard/users`} className='btn btn-secondary btn-block m-t-40 p-t-15 p-b-15'>{i18n.t('Dashboard_Users_ViewList')}</Link>

                                        }

                                        
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </CardBody>
                </Card>
            }




        </Fragment >
    )
}
export default AddUser
